// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3LEQX","resendInfoText":"OnGoingPaymentBox_resendInfoText__8yU1J"};